<template>
  <div class="pl-5 ml-2 h-100">
    <loading loader="bars" :active.sync="isLoading"></loading>
    <div class="row h-100">
      <Role />
      <div class="col-12 p-0 d-block d-sm-none">
        <a
          class="btn btn-brown btn-sm btn-block"
          data-toggle="collapse"
          href="#collapseExample"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample"
        >新增營業時段</a>
      </div>
      <div
        class="col-12 col-sm-4 col-xl-3 p-4 vh-100 collapse show addTimeBox"
        id="collapseExample"
      >
        <div class="card h-100 bg-navy off-white">
          <div class="card-body pb-xl-0">
            <h3 class="card-title text-center">營業時段</h3>
          </div>
          <ul class="card-body d-flex flex-column align-items-center allTheTime">
            <li class="itemTiem row mb-4 shadow-lg" v-for="(item,index) in AllTime" :key="index">
              <div class="col-12 col-xl-5 p-0 d-flex justify-content-between">
                <select
                  class="custom-select input-time"
                  :value="item.CheckIn.substr(0,2)"
                  @input="updateTime(index,'CheckInHour')"
                >
                  <option v-for="index in 24" :key="index" :value="int(index)">{{ int(index) }}</option>
                </select>
                <span class="h3 mb-0 pt-2 pt-sm-0 pt-xl-0 pt-lg-2">:</span>
                <select
                  class="custom-select input-time"
                  :value="item.CheckIn.substr(3,2)"
                  @input="updateTime(index,'CheckInMinute')"
                >
                  <option v-for="index in 60" :key="index" :value="int(index)">{{ int(index) }}</option>
                </select>
              </div>
              <div class="col-12 col-xl p-0">
                <span class="d-flex justify-content-center align-items-center">
                  <i class="las la-chevron-right d-none d-xl-block"></i>
                  <i class="las la-chevron-down d-block d-xl-none"></i>
                </span>
              </div>
              <div class="col-12 col-xl-5 p-0 d-flex justify-content-between">
                <select
                  class="custom-select input-time"
                  :value="item.CheckOut.substr(0,2)"
                  @input="updateTime(index,'CheckOutHour')"
                >
                  <option v-for="index in 24" :key="index" :value="int(index)">{{ int(index) }}</option>
                </select>
                <span class="h3 mb-0 pt-2 pt-sm-0 pt-xl-0 pt-lg-2">:</span>
                <select
                  class="custom-select input-time"
                  :value="item.CheckOut.substr(3,2)"
                  @input="updateTime(index,'CheckOutMinute')"
                >
                  <option v-for="index in 60" :key="index" :value="int(index)">{{ int(index) }}</option>
                </select>
              </div>
              <i class="las la-plus-circle ban" @click="delTime(index, item)"></i>
            </li>
            <div class="addIcon-h" @click="addOpenTime">
              <i class="las la-plus-circle circle"></i>
            </div>
          </ul>
          <div class="card-body">
            <button
              type="button"
              class="btn btn-off-white btn-sm btn-block mb-5 mb-sm-0"
              @click="storageTime"
            >儲存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Role from '@/components/Role.vue'

export default {
  components: {
    Role
  },
  computed: {
    AllTime () {
      return this.$store.state.GetOpenTime
    },
    isLoading () {
      return this.$store.state.isLoading
    }
  },
  methods: {
    addOpenTime () {
      const time = {
        BusinessUserId: this.$store.state.BusinessUser.Id,
        CheckIn: '00:00',
        CheckOut: '00:00'
      }
      var [...times] = this.$store.state.GetOpenTime
      times.push(time)
      this.$store.commit('OpenTime', times)
    },
    delTime (index, item) {
      const vm = this
      this.$swal({
        icon: 'warning',
        title: '確定刪除這筆時間嗎 ?',
        text: '刪除後將無法還原!',
        showCancelButton: true,
        confirmButtonColor: '#B8817D',
        cancelButtonColor: '#545871',
        confirmButtonText: '是的!'
      }).then(result => {
        if (result.value) {
          var [...times] = this.$store.state.GetOpenTime
          times.splice(index, 1)
          this.$store.commit('OpenTime', times)
          if (item.Id) {
            const url =
              'http://imrebooksystem.rocket-coding.com/BusinessOpenTimes/DeleteOpenTime'
            this.axios
              .post(url, { id: item.Id })
              .then(function (res) {
                if (res.data === '刪除成功') {
                  vm.$swal({
                    position: 'top-end',
                    background: '#F7ECEB',
                    icon: 'success',
                    title: '刪除成功',
                    showConfirmButton: false,
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: toast => {
                      toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                      toast.addEventListener(
                        'mouseleave',
                        vm.$swal.resumeTimer
                      )
                    }
                  })
                } else {
                  vm.$swal({
                    position: 'top-end',
                    background: '#F7ECEB',
                    icon: 'error',
                    title: res.data,
                    showConfirmButton: false,
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: toast => {
                      toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                      toast.addEventListener(
                        'mouseleave',
                        vm.$swal.resumeTimer
                      )
                    }
                  })
                }
              })
              .catch(error => console.error(error))
          }
        }
      })
    },
    updateTime (index, str) {
      const message = event.target.value
      this.$store.commit('updateOpenTime', { message, index, str })
    },
    int (index) {
      var int = index - 1
      if (int.toString().length !== 2) {
        return `0${int}`
      } else {
        return int
      }
    },
    storageTime () {
      var [...openTime] = this.$store.state.GetOpenTime
      var newOpenTime = []
      openTime.forEach((item, index) => {
        if (item.upd) {
          delete item.upd
          newOpenTime.push(item)
        }
      })
      const vm = this
      const url =
        'http://imrebooksystem.rocket-coding.com/BusinessOpenTimes/EditAndCreateOpenTime'
      this.axios
        .post(url, newOpenTime)
        .then(function (res) {
          if (res.data === '儲存成功') {
            vm.$swal({
              position: 'top-end',
              background: '#F7ECEB',
              icon: 'success',
              title: '儲存成功',
              showConfirmButton: false,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                toast.addEventListener(
                  'mouseleave',
                  vm.$swal.resumeTimer
                )
              }
            })
          } else {
            vm.$swal({
              position: 'top-end',
              background: '#F7ECEB',
              icon: 'error',
              title: res.data,
              showConfirmButton: false,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                toast.addEventListener(
                  'mouseleave',
                  vm.$swal.resumeTimer
                )
              }
            })
          }
        })
        .catch(error => console.error(error))
    }
  },
  created () {
    this.$store.dispatch('GetOpenTime')
  }
}
</script>

<style lang="scss">
.addIcon-h {
  height: 48px;
  font-size: 3rem;
}
.circle {
  transition: 0.5s;
}
.circle:hover {
  transform: rotate(90deg);
  transition: 0.5s;
}
.addTimeBox {
  min-height: 600px;
}
.itemTiem {
  position: relative;
  background-color: #dadbe6;
  border-radius: 10px;
  color: #545871;
  width: 90%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.ban {
  position: absolute;
  right: -20px;
  top: -20px;
  font-size: 2rem;
  color: #b8817d;
  transform: rotate(45deg);
  transition: 0.5s;
}
.ban:hover {
  transform: rotate(135deg);
  transition: 0.5s;
}
.input-time {
  background-color: transparent;
  border: 0;
  font-size: 1rem;
}
.allTheTime {
  overflow-y: auto;
  height: 100%;
}
.allTheTime::-webkit-scrollbar {
  width: 0 !important;
}
.btn-brown {
  border-radius: 0px;
  border-right: 0px;
  border-bottom: 1px solid #b8817d;
  border-top: 1px solid #b8817d;
  color: #b8817d;
}
.btn-brown:hover {
  background-color: #b8817d;
  color: #545871;
  transition: 0.5s;
}
@media (max-width: 1199.98px) {
  .input-time {
    font-size: 1.5rem;
    padding-left: 30px;
  }
}
@media (max-width: 768px) {
  .input-time {
    font-size: 1rem;
    padding-left: 10px;
  }
}
@media (max-width: 576px) {
  .a {
    height: 95%;
  }
  .addIcon-h {
    font-size: 2rem;
  }
  .input-time {
    font-size: 1.5rem;
    padding-left: 30px;
  }
}
</style>
